<template>
  <div :id="'card_' + course.id" :data-test="'card_' + course.id" class="media-card p-3">
    <article class="card card-hover media-card-section pointer" @click="visitCourse(course)">
      <a class="media-card-thumbnail d-flex align-items-center justify-content-center media-3 rounded-top">
        <div role="button" class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center">
          <i :class="'fas fa-folder-open fa-5x'"></i>
        </div>
      </a>
      <div class="card-body py-1 px-3 align-middle">
        <h5 class="h6 nav-heading my-2 text-start min-height-45">
          <a role="button">
            <span v-if="cardTitleText(course.name).length > 30">
              {{ cardTitleText(course.name).slice(0,30) }}...
            </span>
            <span v-else>
              {{ cardTitleText(course.name) }}
            </span>
          </a>
        </h5>
        <a role="button" class="media-card-read-more">{{ $t('CardSmall.read-more') }}</a>
      </div>
      <div class="card-footer" style="border-top: none !important; padding: 0 1rem !important;">
        <div class="media-2 text-left flex-nowrap">
          <div class="row g-0 text-start">
            <div class="col-xl-6 col-lg-12 col-md-6 col-sm-6 py-1">
              <div class="ms-1">Progress</div>
            </div>
          </div>
        </div>
        <!-- if presenters are there-->
        <div v-if="course.presenters.length > 0" class="row g-0 pt-1">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 dropdown text-start">
            <div ref="anchor" class="avatar-group avatar-group-overlapped mr-40 mt-25 dropbtn" @mouseenter="reinitilizePopper()">
              <div v-for="(p, i) in course.presenters.slice(0, 2)" :key="'presenter-' + i" class="avatar avatar-small">
                <img :src="p.image" :alt="p.name" class="avatar-img rounded-circle" height="80%" width="80%" />
              </div>
              <div class="presenter-facepile-text" style="padding-left: 15px;">
                {{ course.presenters.slice(0, 1)[0].name }} <br />
                <span v-if="course.presenters.length > 1">
                  {{ $t('and-others', { num: parseInt(course.presenters.length - 1) }) }}
                </span>
              </div>
            </div>
            <ul :id="'anchordropdown' + index" ref="anchordropdown" class="list-group dropdown-content">
              <li v-for="(p, i) in course.presenters.slice(0, course.presenters.length)" :key="'presenter-' + i" class="list-group-item">
                <span class="pull-left ms">
                  <div :key="'presenter-' + i" class="avatar avatar-small">
                    <img :src="p.image" :alt="p.name" height="35" width="35" class="avatar-img rounded-circle" />
                  </div>
                </span>
                {{ p.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import { createPopper } from '@popperjs/core';
import truncate from 'lodash/truncate';

export default {
  name: 'CourseCardSmall',
  props: {
    course: {
      type: Object,
      default: null,
    },
    columns: {
      type: Array,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    network: {
      type: [Object, Array],
      default: null,
    },
  },
  data() {
    return {
      popper: {},
    };
  },
  mounted() {
    this.initPoppers();
  },
  methods: {
    // Initializes the Popover feature for ALL presenter dropdowns (for certain cases when we exceed >4 presenters)
    initPoppers() {
      // TODO: destroy any registered poppers
      //
      let anchorEl = this.$refs.anchor;
      let anchordropdownEl = this.$refs.anchordropdown;

      // initialize popper's
      if (anchorEl && anchordropdownEl) {
        this.popper = createPopper(anchorEl, anchordropdownEl, {
          placement: 'auto',
        });
      }
    },
    reinitilizePopper() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.popper.update();
        }, 100);
      });
    },
    visitCourse(c) {
      if (c.permission === 'authorized' && !this.$auth.auth) {
        this.$bus.emit('show-sign-in', c.url.view, "This course is protected, please sign in to continue.");
      } else {
        // going to preview first
        let route = 'courses/preview/' + c.slug;
        window.open(route, '_blank');
      }
    },
    cardTitleText(title) {
      return truncate(title, {
        length: 40,
        omission: '',
      });
    },
  },
};
</script>
<style scoped>
.media-card {
  top: 0px;
  visibility: visible;
  left: 0px;
  opacity: 1;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: transform, opacity;
}
/*.media-card:hover {*/
/*  -webkit-box-shadow: -0.0625rem 0 0.625rem 0 rgb(0 0 0 / 7%), 0.3125rem 1.25rem 2.5rem 0 rgb(0 0 0 / 4%) !important;*/
/*  box-shadow: -0.0625rem 0 0.625rem 0 rgb(0 0 0 / 7%), 0.3125rem 1.25rem 2.5rem 0 rgb(0 0 0 / 4%) !important;*/
/*}*/
.media-card-thumbnail {
  min-height: 125px;
  text-decoration: none;
}
.card-img-top:hover {
  text-decoration: none;
}
.media-card-section {
  min-height: 250px;
}
.presenter-facepile-text {
  font-size: 0.7rem;
  line-height: 1.2;
  letter-spacing: inherit;
  font-family: inherit;
  margin-bottom: unset;
}
/*Avatar*/
.avatar {
  font-size: 1rem;
  position: relative;
  display: inline-block;
  width: 3.875rem;
  height: 3.875rem;
}
.avatar-small {
  width: 1.875rem;
  height: 1.875rem;
}
.avatar .avatar-img {
  width: 80%;
  height: 80%;
  -o-object-fit: cover;
  object-fit: cover;
}
.avatar .avatar-text {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  text-transform: uppercase;
  overflow: hidden;
  background: #fff;
  font-weight: 600;
  color: #00acf0;
}
.avatar .avatar-text .initial-wrap {
  display: table;
  width: 100%;
  height: 100%;
}
.avatar .avatar-text .initial-wrap > span {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.avatar .avatar-text:before {
  content: '';
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(178, 230, 250, 0.5);
}
.avatar .avatar-text.avatar-text-indigo {
  color: #3a55b1;
}
.avatar .avatar-text.avatar-text-indigo:before {
  background: rgba(196, 204, 231, 0.5);
}
.avatar-group {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.avatar-group .avatar {
  font-size: 0.9rem;
  width: 2.625rem;
  height: 2.625rem;
}
.avatar-group .avatar .avatar-img,
.avatar-group .avatar .avatar-text {
  border: 2px solid #fff;
}
.avatar-group.avatar-group-overlapped .avatar {
  margin-right: -13px;
}
.avatar-group.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-group.avatar-group-lg .avatar {
  font-size: 0.95rem;
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -15px;
}
.avatar-group.avatar-group-sm .avatar {
  font-size: 0.6rem;
  width: 2rem;
  height: 2rem;
}
.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -10px;
}
.avatar-group.avatar-group-overlapped .avatar {
  z-index: 1;
}
.avatar-group.avatar-group-overlapped .avatar:first-child {
  z-index: 2;
}
.avatar-group.avatar-group-overlapped .avatar:last-child {
  z-index: 0;
}
.dropbtn {
  padding: 0px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.dropbtn:hover {
  padding: 0px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.dropdown {
  position: relative;
}
.dropdown-content {
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 98;
  max-height: 0;
  min-width: 250px;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}
.dropdown-down {
  bottom: 100%;
}
.dropdown-up {
  bottom: unset;
}
.dropdown-content a {
  color: black;
  background-color: #f9f9f9;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content a:hover {
  background-color: #e2e2e2;
}
.dropdown:hover .dropdown-content {
  max-height: 300px;
  min-width: 250px;
  width: 250px;
  margin-top: 5%;
  transition: max-height 0.25s ease-in;
  overflow: hidden;
  overflow-y: scroll;
}
.dropdown:hover .dropbtn {
  transition: max-height 0.25s ease-in;
}
.cursor-default {
  cursor: default;
}
.media-card-read-more {
  color: #005f9a;
  float: left;
}
</style>